import { show_carusel } from './quotes-component.js';
export const initQuotes = ($, sliderContainer) => {
  const language = sliderContainer.dataset.language;
  const version = sliderContainer.dataset.version;
  const jsonFolder = '/wp-content/themes/doppler_site/assets/js/quotes-component/json/';
  const jsonFile = sliderContainer.dataset.json;
  const jsonUrl = jsonFolder + jsonFile + '?v=' + version;
  sliderContainer.classList.add('quotes-component');
  // Plantilla del quote
  const template = `
  <div class="quotes-component__item">
    <p class="quotes-component__item__text">{desc}</p>
    <div class="quotes-component__item__footer">
      <div class="quotes-component__item__footer__author">
        <div class="quotes-component__item__footer__author__img">
          <img src="/wp-content/themes/doppler_site/img/quotes/author/{author-img}" alt="Author">
        </div>
        <div class="quotes-component__item__footer__author__desc">
          <p>{author}</p>
          <img src="/wp-content/themes/doppler_site/img/quotes/logo/{company-img}" alt="Logo">
        </div>
      </div>
      {link}
    </div>
  </div>
`;

  // Realizar la solicitud para obtener el JSON
  fetch(jsonUrl)
    .then((response) => response.json())
    .then((data) => {
      // Obtener la sección 'quotes' del JSON
      const quotes = data[0].quotes;

      // Construir el contenido del slider en una cadena
      let sliderContent = `
      <div class="quotes-component__container">
        <div class="quotes-component__slider">
    `;

      // Iterar sobre los quotes
      quotes.forEach((quote) => {
        // Verificar si hay una versión en el idioma especificado
        if (quote[language]) {
          // Construir el contenido de quoteItem como una cadena
          let quoteItemContent = template.trim();
          quoteItemContent = quoteItemContent.replace('{desc}', quote[language].desc);
          quoteItemContent = quoteItemContent.replace('{author}', quote.author);
          quoteItemContent = quoteItemContent.replace('{author-img}', quote['author-img']);
          quoteItemContent = quoteItemContent.replace('{company-img}', quote['company-img']);
          quoteItemContent = quoteItemContent.replace('{link}', quote[language].link);

          // Agregar el contenido de quoteItem a sliderContent
          sliderContent += quoteItemContent;
        }
      });

      // Cerrar el contenido del slider
      sliderContent += `
        </div>
      </div>
    `;

      // Establecer el contenido del contenedor del slider
      sliderContainer.innerHTML = sliderContent;

      // Obtener la cantidad de elementos dentro del contenedor
      const quoteSlider = sliderContainer.querySelector('.quotes-component__slider');
      const quoteItemsCount = sliderContainer.querySelectorAll('.quotes-component__item').length;

      // Verificar la cantidad de elementos y agregar la clase correspondiente
      if (quoteItemsCount > 2) {
        quoteSlider.classList.add('slider');
        show_carusel($);
      } else {
        quoteSlider.classList.add('no-slider');
      }
    })
    .catch((error) => console.error('Error fetching JSON:', error));
};
